import React from 'react';
import { Layout, BackTop } from 'antd';

import 'antd/dist/antd.css';
import '../assets/css/resturants.css';

import FoodItemsList from '../components/FoodItemsList';
import ReactFlickSlider from '../components/ReactFlickSlider';

import { ResturantsPageProps } from '../common/types';

const ResturantsPage = (props: ResturantsPageProps) => {
  const { Content } = Layout;

  return (
    <div>
      <Layout>
        <Content className="site-layout">
          <div className="site-layout-background">
            <div className="flick-slider-card-wrapper">
              <ReactFlickSlider />
            </div>
            <div className="site-card-wrapper">
              <FoodItemsList />
            </div>
          </div>
          <BackTop />
        </Content>
      </Layout>
    </div>
  );
};

export default ResturantsPage;
